/*
  Water hardness map page (sections/cq-hardness-map.liquid), v3.
    landing   the server-rendered page. Its map shades each state by its average and draws a dot for every ZIP code with
              a labeled utility or nearby-well figure (assets/cq-hm-dots.js, loaded after first paint). Hover a state for its average;
              click it (or ?state=AZ, or Browse a state) and the map zooms smoothly into it while the rail beside the map
              shows the state's average and its hardest and softest cities. Back or "All states" zooms out.
    result    ?zip=12345 (and &source=well): the figure, the full-range bar and who reported it beside a map that zooms
              from the US to the ZIP's own pin, what it means, a recommendation the shopper steers by preference with a
              selected-variant product link, the sizing hand-off and the expert path.
  Views change through history.pushState, so Back returns and a shared link opens straight to a view.

  Recommendations follow Content Pipeline V2/00-rules/product-truth.md and AJ 2026-10-18 21:27 / 2026-10-19 17:06: at
  hard and very hard city water the softener leads and the shopper can choose lower upkeep (salt-free conditioner); at
  moderate city water the conditioner leads with the softener one tap away; at 25 gpg or more a lower-upkeep choice
  still suggests the softener and says why; soft water says "you may not need a salt-based water softener"; a nearby or
  older figure leads with a test. The headline follows the chosen preference. Analytics carry the band, match kind,
  source and preference, never the ZIP.
*/
(function () {
  'use strict';
  var root = document.getElementById('cq-hardness-map');
  var L = window.CQHardnessLookup;
  if (!root || !L || root.hasAttribute('data-cqhm-js')) return;
  root.setAttribute('data-cqhm-js', '');
  document.documentElement.classList.add('cqhm-js');

  var ds = root.dataset;
  L.configure({data: ds.dataSrc, coords: ds.coordsSrc, wells: ds.wellsSrc, areaBase: ds.areaBase, areaMissing: ds.areaMissing, useArea: ds.useDb !== '0'});

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var landing = $('[data-cqhm-landing]'), app = $('[data-cqhm-app]'), view = $('[data-cqhm-view]'), live = $('[data-cqhm-live]');
  var form = $('[data-cqhm-form]'), zipInput = $('[data-cqhm-zip]'), go = $('[data-cqhm-go]'), hint = $('[data-cqhm-hint]'), errorEl = $('[data-cqhm-error]');
  var mini = $('[data-cqhm-mini]'), zip2 = $('[data-cqhm-zip2]'), field = $('[data-cqhm-field]');
  var railUs = $('[data-cqhm-rail-us]'), railState = $('[data-cqhm-rail-state]');
  var json = function (sel) { try { return JSON.parse(($(sel) || {}).textContent || '{}'); } catch (_) { return {}; } };
  var catalog = json('script[data-cqhm-catalog]');
  var signImgs = $$('.cqhm-sign-photo img').map(function (im) { return {src: im.getAttribute('src'), srcset: im.getAttribute('srcset') || '', alt: im.getAttribute('alt') || ''}; });
  var stateAvg = json('script[data-cqhm-states-json]');
  var statesMarkup = ($('[data-cqhm-states]') || {}).innerHTML || '';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var wellsOn = ds.wells !== '0';
  var current = null, pref = null, started = false, seq = 0;

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); };
  var gpgText = function (g) { return (Math.round(g * 10) / 10).toFixed(1); };
  var num = function (n) { try { return Number(n).toLocaleString('en-US'); } catch (_) { return String(n); } };
  var STATES = {AK:['Alaska',[-57.6,465,202.9,604.1]],AL:['Alabama',[641.5,379.7,710.8,492.6]],AR:['Arkansas',[523,352.2,613.7,434.7]],AZ:['Arizona',[142.3,313.3,264.6,456.3]],CA:['California',[18.5,160,162.8,407.1]],CO:['Colorado',[264.6,237.2,395.3,340.7]],CT:['Connecticut',[871.2,177.7,902.2,208.3]],DC:['Washington, DC',[825.9,265.3,829.7,269.9]],DE:['Delaware',[844.9,241,863.7,272.5]],FL:['Florida',[660.3,464.9,824,606.6]],GA:['Georgia',[689.2,373.7,786.9,476]],HI:['Hawaii',[216.2,528.1,332.1,603.1]],IA:['Iowa',[487.5,193.3,596.1,264.7]],ID:['Idaho',[148.9,35.9,256,209.6]],IL:['Illinois',[575.1,212.4,646.8,340.1]],IN:['Indiana',[638,223.9,693.7,320.2]],KS:['Kansas',[389.7,271.9,522.8,344]],KY:['Kentucky',[614,283.2,747.1,351.5]],LA:['Louisiana',[535,433.1,639,523.6]],MA:['Massachusetts',[870.6,154.8,933,189.2]],MD:['Maryland',[782.3,244.6,863.7,285.3]],ME:['Maine',[890.9,45.8,957.1,150.1]],MI:['Michigan',[585.3,84.4,721.5,227.6]],MN:['Minnesota',[479.3,62.2,597.6,195.3]],MO:['Missouri',[502,259.6,621.8,364]],MS:['Mississippi',[582.2,384,646.5,495.5]],MT:['Montana',[193.3,39,376.9,155.7]],NC:['North Carolina',[712.6,315.9,871.3,386.1]],ND:['North Dakota',[371.1,65.7,489.3,139.9]],NE:['Nebraska',[361.4,201,509.9,275.2]],NH:['New Hampshire',[880.6,102.4,910.2,164.8]],NJ:['New Jersey',[849.2,204,873.2,259.1]],NM:['New Mexico',[246.8,328,372.5,458.4]],NV:['Nevada',[83.3,179.2,197.7,356.2]],NY:['New York',[767.5,117.8,903.1,221.4]],OH:['Ohio',[685.8,209,761.1,295]],OK:['Oklahoma',[371.6,339.4,526.8,421.2]],OR:['Oregon',[31.1,68.7,175.7,190.7]],PA:['Pennsylvania',[756.1,192.1,860.6,259.9]],RI:['Rhode Island',[898.8,176,912.8,196]],SC:['South Carolina',[731.2,364.7,822.8,434.6]],SD:['South Dakota',[365.3,134.3,490.8,218.5]],TN:['Tennessee',[602.8,333.4,756,386.7]],TX:['Texas',[294.3,350.7,546.1,597.6]],UT:['Utah',[176,201.1,277.1,328]],VA:['Virginia',[719.8,259.1,862.5,338.7]],VT:['Vermont',[857.6,110.5,887.9,167.6]],WA:['Washington',[63,13,183.6,102.4]],WI:['Wisconsin',[547.4,111.5,643.9,215.4]],WV:['West Virginia',[733.2,239.2,813.9,320.1]],WY:['Wyoming',[243.5,142,369.1,246.5]]};
  var stateName = function (st) { return (STATES[st] && STATES[st][0]) || st; };
  var place = function (p) { return p ? esc(p.city) + (p.state ? ', ' + esc(p.state) : '') : ''; };
  var US = [0, 0, 975, 610];

  function track(name, payload) {
    var p = {quiz: 'hardness-map'};
    for (var k in payload || {}) if (Object.prototype.hasOwnProperty.call(payload, k)) p[k] = payload[k];
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, p); } catch (_) { /* analytics never blocks the page */ }
    try { root.dispatchEvent(new CustomEvent('cqq:event', {bubbles: true, detail: {name: name, payload: p}})); } catch (_) { /* old browsers */ }
  }

  /* ------------------------------------------------------------------ colour: the same ramp as the generated state fills
     (heatColor() in tools/build-hardness-map-tables.mjs) */
  var STOPS = [[0, [230, 235, 252]], [60, [179, 194, 245]], [120, [106, 128, 230]], [180, [43, 47, 176]], [270, [12, 12, 74]]];
  function heatColor(ppm) {
    var p = Math.max(0, Number(ppm) || 0);
    for (var i = 1; i < STOPS.length; i++) {
      if (p <= STOPS[i][0] || i === STOPS.length - 1) {
        var a = STOPS[i - 1], b = STOPS[i], t = Math.min(1, (p - a[0]) / (b[0] - a[0]));
        return '#' + a[1].map(function (v, k) { var h = Math.round(v + (b[1][k] - v) * t).toString(16); return h.length < 2 ? '0' + h : h; }).join('');
      }
    }
    return '#0c0c4a';
  }

  /* ------------------------------------------------------------------ projection: d3 geoAlbersUsa, scale 1300,
     translate 487.5 305 (the frame of snippets/cq-hm-us-states.liquid), points only */
  var project = (function () {
    var RAD = Math.PI / 180, EPS = 1e-6, K = 1300, TX = 487.5, TY = 305;
    function conic(rotate, center, parallels, k, tx, ty, clip) {
      var y0 = parallels[0] * RAD, sy0 = Math.sin(y0), n = (sy0 + Math.sin(parallels[1] * RAD)) / 2;
      var c = 1 + sy0 * (2 * n - sy0), r0 = Math.sqrt(c) / n, dl = rotate * RAD;
      function raw(l, p) { var r = Math.sqrt(c - 2 * n * Math.sin(p)) / n; l *= n; return [r * Math.sin(l), r0 - r * Math.cos(l)]; }
      var ctr = raw(center[0] * RAD, center[1] * RAD);
      return function (lon, lat) {
        var l = lon * RAD + dl;
        l = l > Math.PI ? l - 2 * Math.PI : l < -Math.PI ? l + 2 * Math.PI : l;
        var p = raw(l, lat * RAD), x = tx + k * (p[0] - ctr[0]), y = ty - k * (p[1] - ctr[1]);
        return x >= clip[0] && x <= clip[2] && y >= clip[1] && y <= clip[3] ? [x, y] : null;
      };
    }
    var lower48 = conic(96, [-0.6, 38.7], [29.5, 45.5], K, TX, TY, [TX - 0.455 * K, TY - 0.238 * K, TX + 0.455 * K, TY + 0.238 * K]);
    var alaska = conic(154, [-2, 58.5], [55, 65], K * 0.35, TX - 0.307 * K, TY + 0.201 * K, [TX - 0.425 * K + EPS, TY + 0.120 * K + EPS, TX - 0.214 * K - EPS, TY + 0.234 * K - EPS]);
    var hawaii = conic(157, [-3, 19.9], [8, 18], K, TX - 0.205 * K, TY + 0.212 * K, [TX - 0.214 * K + EPS, TY + 0.166 * K + EPS, TX - 0.115 * K - EPS, TY + 0.234 * K - EPS]);
    return function (lon, lat) { return lower48(lon, lat) || alaska(lon, lat) || hawaii(lon, lat); };
  })();
  var MILE = 1300 / 3958.8;

  /* ------------------------------------------------------------------ map dots (explicit ZIP and evidence source),
     decoded once from cq-hm-dots.js */
  var dotsP = null;
  function loadDots() {
    if (dotsP) return dotsP;
    dotsP = new Promise(function (resolve) {
      var done = function () {
        var D = window.CQHMDots, out = {};
        if (!D || !D.d) { resolve(null); return; }
        Object.keys(D.d).forEach(function (st) {
          var s = D.d[st], list = [];
          for (var i = 0; D.version === 2 && i + 18 <= s.length; i += 18) {
            var source = s.charAt(i + 17) === 'w' ? 'well' : 'city';
            if (source === 'well' && !wellsOn) continue;
            list.push({x: parseInt(s.substr(i, 3), 36) / 10, y: parseInt(s.substr(i + 3, 3), 36) / 10, ppm: parseInt(s.substr(i + 6, 4), 36), n: parseInt(s.substr(i + 10, 3), 36), zip: ('00000' + parseInt(s.substr(i + 13, 4), 36)).slice(-5), source: source, st: st});
          }
          out[st] = list;
        });
        resolve({by: out, names: D.names || [], n: D.n || 0});
      };
      if (window.CQHMDots) { done(); return; }
      var sc = document.createElement('script');
      sc.src = ds.dotsSrc; sc.async = true;
      sc.onload = done; sc.onerror = function () { resolve(null); };
      document.head.appendChild(sc);
    });
    return dotsP;
  }
  var BUCKET = 10, BUCKETS = 28, bucketColor = [];
  for (var bi = 0; bi < BUCKETS; bi++) bucketColor.push(heatColor(bi * BUCKET + BUCKET / 2));

  /* ------------------------------------------------------------------ the map engine: SVG states scaled by viewBox, dots
     on a canvas, pins and labels as HTML at fixed pixel sizes, all driven by one view box that eases between frames */
  var ease = function (t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };
  function MapView(box, opts) {
    this.box = box; this.opts = opts || {};
    this.svg = box.querySelector('svg'); this.canvas = box.querySelector('canvas'); this.overlay = box.querySelector('[data-cqhm-overlay]');
    this.ctx = this.canvas && this.canvas.getContext ? this.canvas.getContext('2d') : null;
    this.vb = (this.opts.vb || US).slice(); this.dots = []; this.marks = []; this.lines = []; this.rings = [];
    this.W = 0; this.H = 0; this.raf = 0; this.anim = null;
    var self = this;
    this.measure();
    if ('ResizeObserver' in window) { this.ro = new ResizeObserver(function () { self.measure(); self.draw(); }); this.ro.observe(box); }
    else window.addEventListener('resize', function () { self.measure(); self.draw(); });
  }
  MapView.prototype.measure = function () {
    var r = this.box.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.W = r.width; this.H = r.height;
    if (this.canvas) { this.canvas.width = Math.round(r.width * dpr); this.canvas.height = Math.round(r.height * dpr); this.dpr = dpr; }
  };
  // the screen transform of "xMidYMid meet" (or "slice") for a view box
  MapView.prototype.tf = function (vb) {
    vb = vb || this.vb;
    var sx = this.W / vb[2], sy = this.H / vb[3], k = this.opts.slice ? Math.max(sx, sy) : Math.min(sx, sy);
    return {k: k, ox: (this.W - vb[2] * k) / 2 - vb[0] * k, oy: (this.H - vb[3] * k) / 2 - vb[1] * k};
  };
  MapView.prototype.px = function (p, t) { t = t || this.tf(); return [p[0] * t.k + t.ox, p[1] * t.k + t.oy]; };
  MapView.prototype.draw = function () {
    if (this.svg) this.svg.setAttribute('viewBox', this.vb.map(function (v) { return Math.round(v * 100) / 100; }).join(' '));
    var t = this.tf(), self = this;
    if (this.ctx && this.W) {
      var c = this.ctx, dpr = this.dpr || 1;
      c.setTransform(dpr, 0, 0, dpr, 0, 0);
      c.clearRect(0, 0, this.W, this.H);
      var r = Math.max(1.2, Math.min(3.2, t.k * 1.2)), halo = r + (t.k > 2.2 ? .9 : .45);
      var x0 = -halo, y0 = -halo, x1 = this.W + halo, y1 = this.H + halo;
      var vis = [], buckets = [];
      for (var b = 0; b < BUCKETS; b++) buckets.push([]);
      for (var i = 0; i < this.dots.length; i++) {
        var d = this.dots[i], X = d.x * t.k + t.ox, Y = d.y * t.k + t.oy;
        if (X < x0 || X > x1 || Y < y0 || Y > y1) continue;
        vis.push(X, Y);
        buckets[Math.min(BUCKETS - 1, Math.floor(d.ppm / BUCKET))].push(X, Y);
      }
      this.rings.forEach(function (g) {
        var p = self.px(g.p, t);
        c.beginPath(); c.arc(p[0], p[1], g.miles * MILE * t.k, 0, Math.PI * 2);
        c.fillStyle = 'rgba(23,23,150,.07)'; c.fill(); c.lineWidth = 1.5; c.setLineDash([5, 4]); c.strokeStyle = 'rgba(12,12,74,.55)'; c.stroke(); c.setLineDash([]);
      });
      c.fillStyle = 'rgba(255,255,255,.95)';
      c.beginPath();
      for (var j = 0; j < vis.length; j += 2) { c.moveTo(vis[j] + halo, vis[j + 1]); c.arc(vis[j], vis[j + 1], halo, 0, Math.PI * 2); }
      c.fill();
      for (var q = 0; q < BUCKETS; q++) {
        var bl = buckets[q]; if (!bl.length) continue;
        c.fillStyle = bucketColor[q]; c.beginPath();
        for (var m = 0; m < bl.length; m += 2) { c.moveTo(bl[m] + r, bl[m + 1]); c.arc(bl[m], bl[m + 1], r, 0, Math.PI * 2); }
        c.fill();
      }
      this.lines.forEach(function (ln) {
        var a = self.px(ln[0], t), z = self.px(ln[1], t);
        c.beginPath(); c.moveTo(a[0], a[1]); c.lineTo(z[0], z[1]); c.lineWidth = 2; c.setLineDash([6, 5]); c.strokeStyle = '#0c0c4a'; c.stroke(); c.setLineDash([]);
        c.beginPath(); c.arc(z[0], z[1], 7, 0, Math.PI * 2); c.fillStyle = '#fff'; c.fill(); c.lineWidth = 3; c.strokeStyle = '#0c0c4a'; c.stroke();
      });
      this.k = t.k;
    }
    this.marks.forEach(function (mk) {
      var p = self.px(mk.p, t);
      mk.el.style.transform = 'translate(' + p[0].toFixed(1) + 'px,' + p[1].toFixed(1) + 'px)';
      if (mk.min) mk.el.style.opacity = t.k >= mk.min ? '1' : '0';
    });
  };
  MapView.prototype.setView = function (vb, ms, done) {
    var self = this, from = this.vb.slice();
    cancelAnimationFrame(this.raf);
    if (!ms || reduced) { this.vb = vb.slice(); this.draw(); if (done) done(); return; }
    // zoom in log space around a moving centre, so the zoom feels even (no rush at the start)
    var fc = [from[0] + from[2] / 2, from[1] + from[3] / 2], tc = [vb[0] + vb[2] / 2, vb[1] + vb[3] / 2];
    var fw = Math.log(from[2]), tw = Math.log(vb[2]), ar = vb[3] / vb[2], far = from[3] / from[2], t0 = 0;
    var step = function (ts) {
      if (!t0) t0 = ts;
      var t = Math.min(1, (ts - t0) / ms), e = ease(t);
      var w = Math.exp(fw + (tw - fw) * e), a = far + (ar - far) * e, h = w * a;
      var cx = fc[0] + (tc[0] - fc[0]) * e, cy = fc[1] + (tc[1] - fc[1]) * e;
      self.vb = [cx - w / 2, cy - h / 2, w, h];
      self.draw();
      if (t < 1) self.raf = requestAnimationFrame(step); else { self.vb = vb.slice(); self.draw(); if (done) done(); }
    };
    this.raf = requestAnimationFrame(step);
  };
  MapView.prototype.mark = function (p, html, cls, min) {
    if (!this.overlay) return null;
    var el = document.createElement('span'); el.className = cls; if (html) el.innerHTML = html;
    this.overlay.appendChild(el); this.marks.push({p: p, el: el, min: min || 0});
    return el;
  };
  MapView.prototype.clearMarks = function () { this.marks.forEach(function (m) { m.el.remove(); }); this.marks = []; };
  // the dot nearest a pointer, within 9 px
  MapView.prototype.hit = function (cx, cy) {
    var reach = (this.k || 1) > 2 ? 16 : 10;
    var r = this.box.getBoundingClientRect(), x = cx - r.left, y = cy - r.top, t = this.tf(), best = null, bd = reach * reach;
    for (var i = 0; i < this.dots.length; i++) {
      var d = this.dots[i], dx = d.x * t.k + t.ox - x, dy = d.y * t.k + t.oy - y, dd = dx * dx + dy * dy;
      if (dd < bd) { bd = dd; best = d; }
    }
    return best;
  };
  function fitBox(b, pad, ar) {
    var w = Math.max(b[2] - b[0], 4), h = Math.max(b[3] - b[1], 4);
    w *= 1 + 2 * pad; h *= 1 + 2 * pad;
    if (w / h > ar) h = w / ar; else w = h * ar;
    return [(b[0] + b[2]) / 2 - w / 2, (b[1] + b[3]) / 2 - h / 2, w, h];
  }
  function around(p, w, ar) { return [p[0] - w / 2, p[1] - w * ar / 2, w, w * ar]; }

  /* ------------------------------------------------------------------ the tooltip */
  function showTip(box, tipEl, x, y, html) {
    if (!tipEl || !box) return;
    tipEl.innerHTML = html;
    tipEl.classList.add('is-on');
    var b = box.getBoundingClientRect(), tw = tipEl.offsetWidth, th = tipEl.offsetHeight;
    var lx = Math.min(Math.max(8, x - b.left - tw / 2), b.width - tw - 8), ly = y - b.top - th - 16;
    if (ly < 8) ly = Math.min(y - b.top + 18, b.height - th - 8);
    tipEl.style.left = lx + 'px'; tipEl.style.top = ly + 'px';
  }
  function hideTip(tipEl) { if (tipEl) tipEl.classList.remove('is-on'); }
  function bandTag(f) { return '<span class="cqhm-tag cqhm-tag--' + f.bandKey + '">' + f.bandLabel + '</span>'; }
  function stateTip(st) {
    var a = stateAvg[st];
    if (!a) return '<b>' + esc(stateName(st)) + '</b><span class="cqhm-tip-sub">Select to see its ZIP codes</span>';
    var f = L.figures(a[0]);
    return '<b>' + esc(stateName(st)) + '</b><span class="cqhm-tip-num"><span>' + gpgText(f.gpg) + ' gpg &middot; ' + num(f.ppm) + ' mg/L</span>' + bandTag(f) + '</span><span class="cqhm-tip-sub">State average. Select to zoom in.</span>';
  }
  function dotTip(d, names, clickable) {
    var f = L.figures(d.ppm);
    return '<b>' + esc(names[d.n] || '') + '</b><span class="cqhm-tip-num"><span>' + gpgText(f.gpg) + ' gpg &middot; ' + num(f.ppm) + ' mg/L</span>' + bandTag(f) + '</span>' + (clickable ? '<span class="cqhm-tip-sub">Select to check this ZIP</span>' : '');
  }
  /* ------------------------------------------------------------------ the landing map */
  var mapBox = $('[data-cqhm-map]'), tip = $('[data-cqhm-tip]'), statesG = $('[data-cqhm-states]'), backBtn = $('.cqhm-mapback', mapBox || root);
  var lmap = mapBox ? new MapView(mapBox, {vb: US}) : null;
  var lstate = null, dotsData = null;
  function idle(fn) { if ('requestIdleCallback' in window) requestIdleCallback(fn, {timeout: 1500}); else setTimeout(fn, 400); }
  if (lmap) {
    lmap.draw();
    idle(function () {
      loadDots().then(function (D) {
        if (!D) return;
        dotsData = D;
        if (!lstate) { var all = []; Object.keys(D.by).forEach(function (st) { all = all.concat(D.by[st]); }); lmap.allDots = all; lmap.dots = all; }
        else lmap.dots = D.by[lstate] || [];
        lmap.draw();
      });
    });
    $$('path[data-st]', statesG).forEach(function (p) {
      p.setAttribute('tabindex', '0'); p.setAttribute('role', 'button');
      p.setAttribute('aria-label', stateName(p.getAttribute('data-st')) + (stateAvg[p.getAttribute('data-st')] ? ', average ' + gpgText(L.figures(stateAvg[p.getAttribute('data-st')][0]).gpg) + ' grains per gallon' : ''));
    });
    statesG.addEventListener('pointermove', function (e) {
      if (!canHover) return;
      var p = e.target.closest && e.target.closest('path[data-st]');
      if (lstate && dotsData) {
        var d = lmap.hit(e.clientX, e.clientY);
        if (d) { showTip(mapBox, tip, e.clientX, e.clientY, dotTip(d, dotsData.names, true)); mapBox.style.cursor = 'pointer'; return; }
      }
      mapBox.style.cursor = '';
      if (!p || p.getAttribute('data-st') === lstate) { hideTip(tip); return; }
      showTip(mapBox, tip, e.clientX, e.clientY, stateTip(p.getAttribute('data-st')));
    });
    mapBox.addEventListener('pointerleave', function () { hideTip(tip); });
    statesG.addEventListener('click', function (e) {
      if (lstate && dotsData) {
        var dot = lmap.hit(e.clientX, e.clientY);
        if (dot) {
          hideTip(tip);
          if (dot.zip) runZip(dot.zip, {source: dot.source, via: 'map'});
          return;
        }
      }
      var p = e.target.closest && e.target.closest('path[data-st]');
      if (!p) return;
      var st = p.getAttribute('data-st');
      hideTip(tip);
      if (st === lstate) return;
      openState(st, {via: 'map'});
    });
    statesG.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var p = e.target.closest && e.target.closest('path[data-st]');
      if (!p) return;
      e.preventDefault(); openState(p.getAttribute('data-st'), {via: 'keyboard'});
    });
  }
  var pick = $('[data-cqhm-state-select]');
  var stateQ = $('[data-cqhm-state-q]');
  var menu = $('[data-cqhm-menu]');
  if (pick && stateQ && menu) {
    Array.prototype.forEach.call(pick.options, function (opt) {
      if (!opt.value) return;
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'cqhm-menu-item';
      item.setAttribute('role', 'option');
      item.setAttribute('data-st', opt.value);
      item.textContent = opt.textContent;
      menu.appendChild(item);
    });
    function visibleItems() {
      return Array.prototype.filter.call(menu.querySelectorAll('[data-st]'), function (item) { return !item.hidden; });
    }
    var toggle = $('[data-cqhm-state-toggle]');
    function closeMenu() { menu.hidden = true; stateQ.setAttribute('aria-expanded', 'false'); if (toggle) toggle.setAttribute('aria-expanded', 'false'); }
    function openMenu() { menu.hidden = false; stateQ.setAttribute('aria-expanded', 'true'); if (toggle) toggle.setAttribute('aria-expanded', 'true'); }
    function filterStates() {
      var q = stateQ.value.trim().toLowerCase();
      menu.querySelectorAll('[data-st]').forEach(function (item) {
        var name = item.textContent.toLowerCase();
        var code = item.getAttribute('data-st').toLowerCase();
        item.hidden = !!q && name.indexOf(q) !== 0 && code !== q && name.indexOf(q) < 0;
      });
      openMenu();
      if (q && !visibleItems().length) menu.hidden = true;
      return visibleItems();
    }
    function choose(item) {
      if (!item) return;
      closeMenu();
      stateQ.value = item.textContent;
      openState(item.getAttribute('data-st'), {via: 'type'});
    }
    stateQ.addEventListener('input', filterStates);
    stateQ.addEventListener('focus', function () { if (!stateQ.value.trim()) { menu.querySelectorAll('[data-st]').forEach(function (item) { item.hidden = false; }); } filterStates(); });
    if (toggle) toggle.addEventListener('click', function () {
      if (menu.hidden) { menu.querySelectorAll('[data-st]').forEach(function (item) { item.hidden = false; }); openMenu(); stateQ.focus(); }
      else closeMenu();
    });
    stateQ.addEventListener('keydown', function (e) {
      var shown = visibleItems();
      if (e.key === 'ArrowDown' && shown[0]) { e.preventDefault(); shown[0].focus(); }
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = stateQ.value.trim().toLowerCase();
        var exact = shown.filter(function (item) { return item.textContent.toLowerCase() === q || item.getAttribute('data-st').toLowerCase() === q; })[0];
        choose(exact || (shown.length === 1 ? shown[0] : null));
      }
      if (e.key === 'Escape') closeMenu();
    });
    menu.addEventListener('click', function (e) {
      var item = e.target.closest && e.target.closest('[data-st]');
      if (item) choose(item);
    });
    menu.addEventListener('keydown', function (e) {
      var shown = visibleItems();
      var i = shown.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') e.preventDefault();
      if (e.key === 'ArrowDown' && shown[i + 1]) shown[i + 1].focus();
      if (e.key === 'ArrowUp') { if (shown[i - 1]) shown[i - 1].focus(); else stateQ.focus(); }
      if (e.key === 'Enter' && shown[i]) { e.preventDefault(); choose(shown[i]); }
      if (e.key === 'Escape') { closeMenu(); stateQ.focus(); }
    });
    document.addEventListener('click', function (e) { if (!menu.hidden && !(e.target.closest && e.target.closest('[data-cqhm-pick]'))) closeMenu(); });
  }

  function stateRail(st) {
    var a = stateAvg[st], f = a ? L.figures(a[0]) : null, name = stateName(st);
    var html = '<div><p class="cqhm-eyebrow">State water hardness</p><h2 class="cqhm-st-name" data-cqhm-focus tabindex="-1">' + esc(name) + '</h2></div>';
    if (f) {
      html += '<div><div class="cqhm-st-fig"><p class="cqhm-st-num">' + gpgText(f.gpg) + '<small>gpg</small></p><p class="cqhm-st-mgl">' + num(f.ppm) + ' mg/L</p>' + bandTag(f) + '</div>' +
        '<p class="cqhm-note" style="margin-top:8px">State average, weighted by the people each utility serves.</p></div>' + scaleHtml({gpg: f.gpg, band: f.band});
    } else {
      html += '<p class="cqhm-note">Each dot is a ZIP code. Look up yours for the figure we can show.</p>';
    }
    html += '<div class="cqhm-st-lists" data-cqhm-st-lists></div><div class="cqhm-st-actions"><button type="button" class="cqhm-btn cqhm-btn--sm" data-cqhm-do="focus-zip">Look up your ZIP</button><button type="button" class="cqhm-textlink" data-cqhm-do="us">All states</button></div>';
    return html;
  }
  function fillStateLists(st) {
    var box = $('[data-cqhm-st-lists]', railState);
    if (!box) return;
    mapCities().then(function (list) {
      if (lstate !== st || !box.isConnected) return;
      var seen = {}, mine = list.filter(function (c) { if (c.state !== st || seen[c.city] || /county/i.test(c.city)) return false; seen[c.city] = 1; return true; });
      var row = function (c) { var cf = L.figures(c.ppm, c.gpg); return '<li><span>' + esc(c.city) + '</span><b>' + gpgText(cf.gpg) + ' gpg</b></li>'; };
      var count = dotsData && dotsData.by[st] ? dotsData.by[st].length : 0;
      if (mine.length < 2) { box.innerHTML = count ? '<p class="cqhm-note">' + num(count) + ' ZIP codes are on the map here.</p>' : ''; return; }
      var hard = mine.slice().sort(function (a, b) { return b.ppm - a.ppm; }).slice(0, 5), soft = mine.slice().sort(function (a, b) { return a.ppm - b.ppm; }).slice(0, 5);
      box.innerHTML = '<div><h3>Hardest cities</h3><ol class="cqhm-mini-list">' + hard.map(row).join('') + '</ol></div><div><h3>Softest cities</h3><ol class="cqhm-mini-list">' + soft.map(row).join('') + '</ol></div>' +
        (count ? '<p class="cqhm-note" style="grid-column:1/-1">' + num(count) + ' ZIP codes in ' + esc(stateName(st)) + ' are on the map. A dot named Nearby is the nearest utility or nearby wells, not that ZIP\'s own report.</p>' : '');
    });
  }
  function openState(st, opts) {
    opts = opts || {};
    if (!STATES[st] || !lmap) return;
    cancelLookup();
    if (root.getAttribute('data-view') !== 'landing') show('landing');
    var first = !lstate;
    lstate = st;
    if (opts.push !== false) setUrl({state: st});
    mapBox.setAttribute('data-cqhm-mapmode', 'state');
    $$('path[data-st]', statesG).forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-st') === st); });
    if (backBtn) backBtn.hidden = false;
    if (dotsData) lmap.dots = dotsData.by[st] || [];
    else loadDots().then(function (D) { if (D) { dotsData = D; if (lstate === st) { lmap.dots = D.by[st] || []; lmap.draw(); } } });
    var ar = lmap.H && lmap.W ? lmap.H / lmap.W : 610 / 975;
    lmap.setView(fitBox(STATES[st][1], 0.1, 1 / ar), opts.instant ? 0 : (first ? 640 : 520));
    if (railUs) railUs.hidden = true;
    if (railState) { railState.hidden = false; railState.innerHTML = stateRail(st); railState.style.animation = 'none'; void railState.offsetWidth; railState.style.animation = ''; placeMarks(railState); fillStateLists(st); }
    if (opts.via !== 'link' && opts.via !== 'pop') {
      var r = mapBox.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) mapBox.scrollIntoView({block: 'nearest', behavior: reduced ? 'auto' : 'smooth'});
    }
    var f = stateAvg[st] ? L.figures(stateAvg[st][0]) : null;
    speak(stateName(st) + ' water hardness' + (f ? ': state average about ' + gpgText(f.gpg) + ' grains per gallon, ' + f.bandLabel.toLowerCase() + '.' : '.'));
    track('cq_quiz_state_view', {state: st, via: opts.via || 'map', band: f ? f.bandKey : 'none'});
  }
  function closeState(push) {
    cancelLookup();
    if (!lmap || !lstate) return;
    lstate = null;
    if (push) setUrl({});
    mapBox.setAttribute('data-cqhm-mapmode', 'us');
    $$('path.is-on', statesG).forEach(function (p) { p.classList.remove('is-on'); });
    if (backBtn) backBtn.hidden = true;
    if (lmap.allDots) lmap.dots = lmap.allDots;
    lmap.setView(US, 560);
    if (railState) { railState.hidden = true; railState.innerHTML = ''; }
    if (railUs) railUs.hidden = false;
  }

  /* ------------------------------------------------------------------ views and the address bar */
  function setUrl(params, replace) {
    var q;
    try { q = new URLSearchParams(location.search); } catch (_) { return; }
    ['zip', 'source', 'state'].forEach(function (k) { q.delete(k); });
    for (var k in params) if (params[k]) q.set(k, params[k]);
    var rest = q.toString(), url = location.pathname + (rest ? '?' + rest : '');
    try { history[replace ? 'replaceState' : 'pushState']({cqhm: params}, '', url); } catch (_) { /* file previews */ }
  }
  function show(which) {
    var enteringApp = app && app.hidden;
    root.setAttribute('data-view', which);
    var inApp = which !== 'landing';
    if (landing) landing.hidden = inApp;
    if (app) app.hidden = !inApp;
    if (inApp && enteringApp) window.scrollTo({top: 0, behavior: 'auto'});
    else if (!inApp && lmap) { lmap.measure(); lmap.draw(); }
  }
  function cancelLookup() { seq++; current = null; busy(false); }
  function goHome(push) {
    cancelLookup();
    show('landing');
    current = null;
    if (push) setUrl({});
    if (lstate) closeState(false);
    if (zipInput) zipInput.focus({preventScroll: true});
  }
  function focusView(scope) {
    var h = $('[data-cqhm-focus]', scope || view) || view;
    if (h) { if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1'); h.focus({preventScroll: true}); }
  }
  function speak(text) { if (!live) return; live.textContent = ''; setTimeout(function () { live.textContent = text; }, 60); }

  function route() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (_) { q = null; }
    var z = q ? (q.get('zip') || '').replace(/\D/g, '').slice(0, 5) : '';
    var st = q ? (q.get('state') || '').toUpperCase() : '';
    if (/^\d{5}$/.test(z)) { if (zipInput) zipInput.value = z; runZip(z, {source: q.get('source'), via: 'link', push: false}); return; }
    cancelLookup();
    if (root.getAttribute('data-view') !== 'landing') { show('landing'); }
    if (STATES[st]) { openState(st, {via: lstate ? 'pop' : 'link', push: false}); return; }
    if (lstate) closeState(false);
  }
  window.addEventListener('popstate', function () { route(); });

  var cityList = null;
  function mapCities() { if (!cityList) cityList = L.mapCities().then(null, function () { cityList = null; return []; }); return cityList; }

  /* ------------------------------------------------------------------ the full-range bar (same markup as the section's) */
  var TICKS = [[0, '0'], [18, '3.5'], [36, '7'], [54, '10.5'], [64.6, '15'], [76.4, '20'], [100, '30+ gpg']];
  function scaleX(g) {
    g = Math.max(0, Number(g) || 0);
    if (g <= 10.5) return g / 10.5 * 54;
    return Math.min(100, 54 + (g - 10.5) / 19.5 * 46);
  }
  function scaleHtml(r) {
    var bands = [['Soft', 18], ['Moderate', 18], ['Hard', 18], ['Very hard', 46]];
    var range = r.range ? '<span class="cqhm-scale-range" style="left:' + scaleX(r.range[0]).toFixed(1) + '%;width:' + Math.max(1.5, scaleX(r.range[1]) - scaleX(r.range[0])).toFixed(1) + '%"></span>' : '';
    return '<div class="cqhm-scale" role="img" aria-label="' + esc((r.label || 'Hardness') + ': about ' + gpgText(r.gpg) + ' grains per gallon on a scale from 0 to over 30') + '">' +
      '<ol class="cqhm-scale-bands" aria-hidden="true">' + bands.map(function (b, i) { return '<li style="--w:' + b[1] + '%"' + (i === r.band ? ' class="is-on"' : '') + '>' + b[0] + '</li>'; }).join('') + '</ol>' +
      '<div class="cqhm-scale-bar">' + range + '<span class="cqhm-scale-mark" data-x="' + scaleX(r.gpg).toFixed(2) + '"></span></div>' +
      '<ol class="cqhm-scale-ticks" aria-hidden="true">' + TICKS.map(function (t) { return '<li style="--x:' + t[0] + '%">' + t[1] + '</li>'; }).join('') + '</ol></div>';
  }
  function placeMarks(scope) {
    requestAnimationFrame(function () {
      $$('.cqhm-scale-mark', scope).forEach(function (mk) {
        var bar = mk.parentNode, w = bar.getBoundingClientRect().width;
        mk.style.setProperty('--to', (Number(mk.getAttribute('data-x')) / 100 * w).toFixed(1) + 'px');
      });
    });
  }

  /* ------------------------------------------------------------------ result copy */
  // [title, text, sign picture index in the section's signs list (0 glassware, 1 scale, 2 appliance, 3 laundry, 4 skin, 5 pressure)]
  var MEANS = [
    [['Little scale', 'Soft water leaves little scale on faucets, glassware or inside your water heater.'], ['Easy lather', 'Soap and detergent lather easily, so a little goes a long way.'], ['Softening is optional', 'The EPA notes water softeners are not needed in every home.']],
    [['Spots and slow scale', 'Expect some spots on glasses and slow scale on faucets and showerheads.', 0], ['A little more soap', 'Hard water takes more soap and detergent to get hands, hair and laundry clean.', 3], ['Scale control helps', 'A salt-free conditioner reduces scale buildup without removing the minerals.', 1]],
    [['Scale on fixtures', 'Scale builds up on faucets and showerheads and inside pipes and fixtures.', 1], ['More soap needed', 'Hard water takes more soap and detergent to get hands, hair and laundry clean.', 3], ['Shorter appliance life', 'The EPA notes hard water can shorten the life of water heaters, washing machines and other appliances.', 2]],
    [['Heavy scale', 'Scale can clog pipes, lower the efficiency of electric water heaters and raise heating costs.', 1], ['Shorter appliance life', 'The EPA notes hard water can shorten the life of water heaters, washing machines and other appliances.', 2], ['Dry skin and hair', 'The EPA notes hard water can dry out skin and hair, and soap leaves a film behind.', 4]]
  ];
  var VERB = ['soft', 'moderately hard', 'hard', 'very hard'];
  function headline(r) {
    var v = VERB[r.band];
    if (r.source === 'well') return 'Wells near you usually test ' + v + '.';
    if (r.kind === 'near' && r.regional) return 'Your region may have ' + v + ' water.';
    if (r.kind === 'near') return 'Your area may have ' + v + ' water.';
    if (r.weak) return 'This area\'s older figure reads ' + v + '.';
    if (r.likely) return 'Your water is likely ' + v + '.';
    return 'Your water is ' + v + '.';
  }
  function whereLine(r) {
    if (r.source === 'well') return 'ZIP ' + esc(r.zip) + ' <span aria-hidden="true">&middot;</span> private wells nearby';
    if (r.kind === 'exact' && r.place) return 'ZIP ' + esc(r.zip) + ' <span aria-hidden="true">&middot;</span> ' + place(r.place);
    if (r.kind === 'near') return 'Your ZIP <span aria-hidden="true">&middot;</span> ' + esc(r.zip);
    return 'ZIP ' + esc(r.zip) + ' <span aria-hidden="true">&middot;</span> city water';
  }
  var milesText = function (m) { var x = Math.round(Number(m) || 0); return x < 1 ? 'under a mile' : x === 1 ? 'about 1 mile' : 'about ' + x + ' miles'; };
  function sourceHtml(r) {
    var yr = r.year ? ', ' + esc(r.year) : '';
    if (r.source === 'well') {
      var w = r.well, yrs = w.latestYear ? (w.medianYear && w.medianYear !== w.latestYear ? 'sampled ' + w.medianYear + ' to ' + w.latestYear : 'sampled in ' + w.latestYear) : 'sampled 2021 or later';
      return 'Typical of ' + num(w.wells) + ' measured wells ' + esc(w.areaWords) + ', ' + yrs + '. Half tested between ' + num(w.low) + ' and ' + num(w.high) + ' mg/L.';
    }
    if (r.kind === 'near' && r.regional) return 'Based on regional estimates from water utility reports in your region. Your ZIP does not have its own report on our map yet.';
    if (r.kind === 'near') return 'We estimate this from the nearest report we have' + (r.utility ? ', <b>' + esc(r.utility) + '</b> in ' + place(r.place) : ', <b>' + place(r.place) + '</b>') + ', ' + milesText(r.miles) + ' from your ZIP' + yr + '.';
    if (r.likely) return 'Likely served by <b>' + esc(r.utility) + '</b>, which reported this figure' + (r.year ? ' in ' + esc(r.year) : '') + '. Some ZIP codes have more than one water utility.';
    if (r.weak) return 'An older figure for ' + place(r.place) + ' that is less certain than a utility report.';
    if (r.utility) return 'Reported by <b>' + esc(r.utility) + '</b>' + yr + '.';
    return '';
  }
  function evidenceSummary(r) {
    if (r.source === 'well') return 'Nearby well samples. Test your own well to confirm.';
    if (r.kind === 'near' && r.regional) return 'Based on regional estimates. Test to confirm.';
    if (r.kind === 'near') return 'Nearby utility estimate, ' + milesText(r.miles) + ' away. Your tap may differ.';
    if (r.weak) return 'Older area report. Test your tap to confirm.';
    if (r.likely) return 'Likely utility match. Your tap may differ.';
    return 'Utility report' + (r.year ? ' from ' + r.year : '') + '. Your tap may differ.';
  }
  var ZIP3 = [[5,5,'NY'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[885,885,'TX'],[889,898,'NV'],[900,966,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  function zipState(zip) {
    var p = parseInt(String(zip || '').slice(0, 3), 10);
    for (var i = 0; i < ZIP3.length; i++) if (p >= ZIP3[i][0] && p <= ZIP3[i][1]) return ZIP3[i][2];
    return '';
  }
  function compareHtml(r) {
    var st = (r.place && r.place.state) || zipState(r.zip);
    var row = st && stateAvg[st];
    if (!row || r.gpg == null) return '';
    var avg = L.figures(row[0]);
    var diff = Math.round((Number(r.gpg) - avg.gpg) * 10) / 10;
    var name = stateName(st);
    var mark = function (text) { return '<strong>' + text + '</strong>'; };
    if (Math.abs(diff) < 0.3) return 'About ' + mark('the same') + ' as the ' + name + ' average of ' + gpgText(avg.gpg) + ' gpg.';
    return 'About ' + mark(gpgText(Math.abs(diff)) + ' gpg ' + (diff > 0 ? 'harder' : 'softer')) + ' than the ' + name + ' average of ' + gpgText(avg.gpg) + ' gpg.';
  }
  function cautionHtml(r) {
    if (r.kind === 'near' && r.regional) return 'This is a starting point, not your number. Your own water utility or well can read very differently, so a water test is the way to know before choosing a system.';
    if (r.kind === 'near') return 'Your own water utility can read differently. A water test gives you the number at your tap.';
    if (r.weak) return 'Your own tap may differ. A water test gives your exact number before you choose a system.';
    if (r.source === 'well') return 'Wells on the same road can differ. A well test is the only way to know your own well.';
    return '';
  }

  /* ------------------------------------------------------------------ products: installed photos and a page-owned buy
     block (tank and size choices from the product's own variants; checkout options stay on the product page) */
  var CHECK = '<svg class="cqhm-check" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="9" fill="currentColor"/><path d="m5.2 9.3 2.5 2.4 5.1-5.3" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_TRUCK = '<svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true"><path d="M2 5h10v8H2zM12 8h3.5L18 10.5V13h-6M5.5 15.5a1.5 1.5 0 1 0 0-.1M14.5 15.5a1.5 1.5 0 1 0 0-.1" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  var ICON_PHONE = '<svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true"><path d="M5.5 2.5h2.5l1.2 3.6-1.7 1.2a9 9 0 0 0 5.2 5.2l1.2-1.7 3.6 1.2v2.5a1.5 1.5 0 0 1-1.6 1.5A14 14 0 0 1 4 4.1 1.5 1.5 0 0 1 5.5 2.5Z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  var ICON_RULER = '<svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true"><path d="M3 13.5 13.5 3 17 6.5 6.5 17zM6 10.5l1.5 1.5M8.5 8l2 2M11 5.5l1.5 1.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  var COPY = {
    softener: {name: 'Whole House Water Softener', ticks: ['Removes the calcium and magnesium behind scale, spots and stiff laundry', '48,000 grains (1.5 cu ft) or 60,000 grains (2.0 cu ft) between regenerations', 'Pre and post filtration included; resin lasts 10 to 15 years']},
    conditioner: {name: 'Salt-Free Water Conditioner', ticks: ['Controls scale with no salt, drain line, power or backwash', 'Keeps the minerals in, so your water feels the same', 'Media lasts 5 to 7 years, depending on hardness, iron, chlorine and use']},
    city_test: {name: 'City Water Test', ticks: ['A lab reads your hardness and the rest of your water', 'Your own number, so the system fits the first time']},
    well_test: {name: 'Well Water Test', ticks: ['Your own hardness, plus iron, bacteria and more', 'Those decide the right system for a well']}
  };
  var buyState = {};
  function optLabel(name, value) {
    if (/cubic|resin/i.test(name)) { var m = /^([\d.]+)/.exec(value); return m ? (m[1] === '2' ? '2.0' : m[1]) + ' cu ft' : value; }
    return String(value).replace(/\s+Tank$/i, '');
  }
  function optName(name) { return /structure/i.test(name) ? 'Tank' : /cubic|resin/i.test(name) ? 'Size' : name; }
  function variantOf(p, picks) {
    return p.variants.filter(function (v) { return v.options.every(function (o, i) { return picks[i] == null || picks[i] === o; }); })[0] || null;
  }
  function photo(p, cls, sizes, alt) {
    if (!p || !p.img) return '';
    return '<img class="' + (cls || '') + '" src="' + esc(p.img) + '" srcset="' + esc(p.srcset) + '" sizes="' + (sizes || '(min-width: 1024px) 540px, 100vw') + '" width="' + (p.w || 1122) + '" height="' + (p.h || 1402) + '" alt="' + esc(alt || '') + '" loading="lazy" decoding="async">';
  }
  function buyHtml(key) {
    var p = catalog[key];
    if (!p || !p.variants) return '';
    var st = buyState[key];
    if (!st) { var sel = p.variants.filter(function (v) { return v.id === p.selected; })[0] || p.variants[0]; st = buyState[key] = {picks: sel.options.slice()}; }
    var v = variantOf(p, st.picks) || p.variants[0];
    var rows = (p.options || []).map(function (name, i) {
      var vals = []; p.variants.forEach(function (x) { if (vals.indexOf(x.options[i]) < 0) vals.push(x.options[i]); });
      if (vals.length < 2) return '';
      return '<div class="cqhm-optrow" role="group" aria-label="' + esc(optName(name)) + '"><span>' + esc(optName(name)) + '</span><div>' + vals.map(function (val) {
        return '<button type="button" class="cqhm-optbtn" data-cqhm-opt="' + esc(key) + '" data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="' + (st.picks[i] === val) + '">' + esc(optLabel(name, val)) + '</button>';
      }).join('') + '</div></div>';
    }).join('');
    var ok = v && v.available;
    return (rows ? '<div class="cqhm-opts">' + rows + '</div>' : '') +
      '<div class="cqhm-buy"><p class="cqhm-price">' + esc(v ? v.price : p.price) + '</p>' +
      (ok ? '<a class="cqhm-btn" href="' + esc(p.url) + '?variant=' + v.id + '" data-cqhm-cta="choose-' + esc(key) + '">Choose options</a>' : '<button type="button" class="cqhm-btn" disabled>Sold out</button>') +
      '<a class="cqhm-btn cqhm-btn--line" href="' + esc(p.url) + (v ? '?variant=' + v.id : '') + '" data-cqhm-cta="details-' + esc(key) + '">See details</a><p class="cqhm-buy-err" role="alert" data-cqhm-buy-err></p></div>';
  }
  function reasonsHtml(key, r) {
    var calc = withParam(ds.calcUrl, 'gpg', gpgText(r.gpg));
    var items = ['<li>' + ICON_TRUCK + 'Qualifies for free shipping to the lower 48</li>', '<li>' + ICON_PHONE + 'Lifetime support from our specialists</li>'];
    if (key === 'softener') items.push('<li>' + ICON_RULER + '<a href="' + esc(calc) + '" data-cqhm-cta="calc-inline">Not sure which size? Size it for ' + gpgText(r.gpg) + ' gpg</a></li>');
    return '<ul class="cqhm-reasons">' + items.join('') + '</ul>';
  }
  function featured(key, tag, why, r) {
    var p = catalog[key], c = COPY[key];
    if (!p || !p.url) return '';
    var wide = key === 'city_test' || key === 'well_test';
    return '<article class="cqhm-feat" data-cqhm-feat="' + esc(key) + '"><a class="cqhm-feat-photo' + (wide ? ' cqhm-feat-photo--wide' : '') + '" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + photo(p, '', '(min-width: 1024px) 560px, 100vw') + '<span class="cqhm-chip">' + esc(tag) + '</span></a>' +
      '<div class="cqhm-feat-copy"><h3 class="cqhm-feat-name"><a href="' + esc(p.url) + '" data-cqhm-cta="product-' + esc(key) + '">' + esc(c ? c.name : p.title) + '</a></h3>' +
      (why ? '<p class="cqhm-feat-why">' + why + '</p>' : '') +
      (c ? '<ul class="cqhm-ticks">' + c.ticks.map(function (t) { return '<li>' + CHECK + esc(t) + '</li>'; }).join('') + '</ul>' : '') +
      buyHtml(key) + (r ? reasonsHtml(key, r) : '') + '</div></article>';
  }
  function altRow(key, lead, extra, action) {
    var p = catalog[key], c = COPY[key];
    if (!p || !p.url) return '';
    return '<div class="cqhm-alt"><span class="cqhm-alt-img" aria-hidden="true">' + photo(p, '', '96px') + '</span><div><span class="cqhm-alt-lead">' + esc(lead) + '</span>' +
      '<a class="cqhm-alt-name" href="' + esc(p.url) + '" data-cqhm-cta="product-' + esc(key) + '">' + esc(c ? c.name : p.title) + '</a><span class="cqhm-alt-price">' + (p.varies ? 'From ' : '') + esc(p.price) + '</span>' + (extra || '') + '</div>' +
      (action || '<a class="cqhm-btn cqhm-btn--line cqhm-btn--sm" href="' + esc(p.url) + '" data-cqhm-cta="alt-' + esc(key) + '">See details</a>') + '</div>';
  }
  function withParam(url, k, v) { return url + (url.indexOf('?') >= 0 ? '&' : '?') + k + '=' + encodeURIComponent(v); }

  function chooser() {
    var opt = function (v, t, d) {
      return '<label class="cqhm-opt"><input type="radio" name="cqhm-pref" value="' + v + '"' + (pref === v ? ' checked' : '') + '><span><b>' + t + '</b><small>' + d + '</small></span></label>';
    };
    return '<div class="cqhm-pref-wrap"><p class="cqhm-pref-q" id="cqhm-pref-q">What matters most to you?</p><div class="cqhm-pref" role="radiogroup" aria-labelledby="cqhm-pref-q" data-cqhm-pref>' +
      opt('soft', 'Truly soft water', 'Silky feel, easy lather, no scale') + opt('upkeep', 'Lower upkeep', 'No salt, no regeneration') + '</div></div>';
  }
  var WHY_SOFT = 'A water softener removes the hardness minerals, so you get soft water and far less scale. It uses salt and regenerates on its own.';
  var WHY_LOW = 'A salt-free conditioner controls scale without removing the minerals, with no salt to carry and nothing to regenerate.';
  function recommendation(r) {
    var g = r.gpg, b = r.band, out = '', confirm = r.kind === 'near' || r.weak;
    var calc = withParam(ds.calcUrl, 'gpg', gpgText(g));
    var sizing = function () {
      return '<div class="cqhm-size"><div><h3>Size your softener in a minute.</h3><p>We carry your ' + gpgText(g) + ' gpg over, so you only answer two quick questions about your home.</p></div>' +
        '<a class="cqhm-btn cqhm-btn--line" href="' + esc(calc) + '" data-cqhm-cta="calc">Size my softener</a></div>';
    };
    if (r.source === 'well') {
      out += featured('well_test', 'Start here', 'For a private well, your own test decides the system. Iron, bacteria and other results change what you need.', r);
      if (b >= 2) out += altRow('softener', 'Often paired with hard well water');
      out += '<p class="cqhm-rec-foot"><a class="cqhm-btn" href="' + esc(ds.wellQuizUrl) + '" data-cqhm-cta="well-quiz">Find my well water system</a></p>';
      return {title: 'Know your well, <em>then choose.</em>', body: out};
    }
    if (b === 0) {
      out += featured('conditioner', 'Only if you still see scale', WHY_LOW, r);
      return {title: confirm ? 'Confirm your number, <em>then decide.</em>' : 'You may not need a salt-based water softener.', lead: 'Hardness is one number. The Water Wizard shows what else your utility reports.',
        pre: confirm ? altRow('city_test', 'Confirm your own number first') : '', body: out,
        after: '<p class="cqhm-rec-foot"><a class="cqhm-btn" href="' + esc(ds.wizardUrl) + '" data-cqhm-cta="wizard">Build my water plan</a></p>'};
    }
    if (pref == null) pref = b >= 2 ? 'soft' : 'upkeep';
    var veryHard = g >= 25, title;
    if (pref === 'soft' || veryHard) {
      out += featured('softener', pref === 'soft' ? 'Our pick for soft water' : 'Our pick at this hardness', pref === 'upkeep' ? 'At 25 gpg or more, a softener works better in a home. It removes the minerals instead of only controlling scale.' : WHY_SOFT, r);
      out += pref === 'upkeep'
        ? altRow('conditioner', 'Still prefer no salt?', '<a class="cqhm-alt-note" href="' + esc(ds.helpUrl) + '" data-cqhm-cta="specialist-sizing">Have a specialist confirm the sizing</a>')
        : altRow('conditioner', 'Rather skip the salt?', '', '<button type="button" class="cqhm-btn cqhm-btn--line cqhm-btn--sm" data-cqhm-do="pref" data-v="upkeep">Show lower upkeep</button>');
      title = pref === 'upkeep' ? 'At this hardness, <em>a softener still works best.</em>' : (b >= 2 ? 'A water softener fits <em>this water best.</em>' : 'For truly soft water, <em>a water softener.</em>');
    } else {
      out += featured('conditioner', 'Our pick for lower upkeep', WHY_LOW, r);
      out += altRow('softener', 'Want truly soft water?', '', '<button type="button" class="cqhm-btn cqhm-btn--line cqhm-btn--sm" data-cqhm-do="pref" data-v="soft">Show the softener</button>');
      title = b >= 2 ? 'For lower upkeep, <em>a salt-free conditioner.</em>' : 'A salt-free conditioner <em>handles this water.</em>';
    }
    if (confirm) title = 'Confirm your number, <em>then choose.</em>';
    return {title: title, pre: confirm ? altRow('city_test', 'Confirm your own number first') : '', chooser: chooser(), body: out, after: pref === 'soft' || veryHard ? sizing() : ''};
  }
  function recHtml(rec) {
    return '<div class="cqhm-rec-head"><div><p class="cqhm-eyebrow">What we would suggest</p><h2 class="cqhm-r-h2">' + rec.title + '</h2>' + (rec.lead ? '<p class="cqhm-r-text">' + esc(rec.lead) + '</p>' : '') + '</div>' + (rec.chooser || '') + '</div>' +
      (rec.pre || '') + '<div data-cqhm-rec-body>' + rec.body + '</div>' + (rec.after || '') +
      '<p class="cqhm-rec-foot"><a class="cqhm-textlink" href="' + esc(ds.compareUrl) + '" data-cqhm-cta="compare">Softener or conditioner? Read the comparison</a></p>';
  }

  /* ------------------------------------------------------------------ the result view */
  var rmap = null;
  function resultMapHtml(r) {
    var caption = r.source === 'well' ? (r.well && (r.well.area === '10' || r.well.area === '25') ? 'The ring shows the ' + r.well.area + ' mile area the wells came from.' : 'The pin marks your ZIP code.')
      : r.kind === 'near' && r.regional ? 'The pin marks your ZIP code.' : r.kind === 'near' ? 'The pin is your ZIP. The line runs to the nearby report this estimate is based on.' : r.kind === 'miss' ? 'The pin marks your ZIP code.' : 'The pin marks your ZIP code. Dot labels distinguish utility reports, nearby estimates and sampled wells.';
    return '<figure class="cqhm-rmap"><div class="cqhm-map" data-cqhm-rmap><svg viewBox="0 0 975 610" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><g class="cqhm-states">' + statesMarkup + '</g></svg><canvas class="cqhm-canvas" aria-hidden="true"></canvas><div class="cqhm-overlay" aria-hidden="true" data-cqhm-overlay></div><div class="cqhm-tip" aria-hidden="true" data-cqhm-rtip></div></div>' +
      '<figcaption>' + caption + '</figcaption></figure>';
  }
  function startResultMap(r) {
    var box = $('[data-cqhm-rmap]', view);
    if (!box) return;
    var pt = r.point && isFinite(r.point.lat) ? project(r.point.lng, r.point.lat) : null;
    var cityPt = r.place && r.kind === 'near' && !r.regional ? project(r.place.lng, r.place.lat) : null;
    var center = pt || (r.place ? project(r.place.lng, r.place.lat) : null);
    var st = r.place && r.place.state;
    rmap = new MapView(box, {vb: US, slice: true});
    if (st) $$('path[data-st]', box).forEach(function (p) { if (p.getAttribute('data-st') === st) p.classList.add('is-on'); });
    var ar = rmap.H / rmap.W || .75;
    var span = r.kind === 'near' && pt && cityPt ? Math.max(70, Math.hypot(pt[0] - cityPt[0], pt[1] - cityPt[1]) * 2.6) : r.well && r.well.area === '25' ? 72 : 92;
    var start = st && STATES[st] ? fitBox(STATES[st][1], .25, 1 / ar) : US.slice();
    rmap.vb = start;
    if (pt) { rmap.mark(pt, '', 'cqhm-pin'); rmap.mark(pt, 'Your ZIP', 'cqhm-pinlabel'); }
    if (cityPt && pt) rmap.lines.push([pt, cityPt]);
    if (pt && r.well && (r.well.area === '10' || r.well.area === '25')) rmap.rings.push({p: pt, miles: Number(r.well.area)});
    rmap.draw();
    var target = center ? around(cityPt && pt ? [(pt[0] + cityPt[0]) / 2, (pt[1] + cityPt[1]) / 2] : center, span, ar) : start;
    var go2 = function () { if (current === r) rmap.setView(target, 900); };
    if (r.source !== 'well') {
      loadDots().then(function (D) {
        if (!D || current !== r) { go2(); return; }
        var all = []; Object.keys(D.by).forEach(function (k) { all = all.concat(D.by[k]); });
        rmap.dots = all; rmap.draw();
        labelPlaces(r, target);
        setTimeout(go2, reduced ? 0 : 250);
        var rtip = $('[data-cqhm-rtip]', view);
        box.addEventListener('pointermove', function (e) { if (!canHover) return; var d = rmap.hit(e.clientX, e.clientY); if (d) showTip(box, rtip, e.clientX, e.clientY, dotTip(d, D.names)); else hideTip(rtip); });
        box.addEventListener('pointerleave', function () { hideTip(rtip); });
      });
    } else setTimeout(go2, reduced ? 0 : 250);
  }
  // town names around the pin, from the sourced city list, appearing once the map has zoomed in
  function labelPlaces(r, vb) {
    mapCities().then(function (list) {
      if (current !== r || !rmap) return;
      var pt = r.point && isFinite(r.point.lat) ? project(r.point.lng, r.point.lat) : null;
      var picked = [], seen = {};
      list.map(function (c) { return {c: c, p: project(c.lng, c.lat)}; })
        .filter(function (x) { return x.p && !/county/i.test(x.c.city) && x.p[0] > vb[0] + vb[2] * .06 && x.p[0] < vb[0] + vb[2] * .8 && x.p[1] > vb[1] + vb[3] * .08 && x.p[1] < vb[1] + vb[3] * .94; })
        .sort(function (a, b) { return (b.c.zips || []).length - (a.c.zips || []).length; })
        .forEach(function (x) {
          if (picked.length >= 5 || seen[x.c.city]) return;
          // keep clear of the pin and its "Your ZIP" label, which sits up and to the right of it
          if (pt && x.p[0] > pt[0] - vb[2] * .1 && x.p[0] < pt[0] + vb[2] * .32 && Math.abs(x.p[1] - pt[1]) < vb[3] * .14) return;
          if (picked.some(function (o) { return Math.abs(o[0] - x.p[0]) < vb[2] * .22 && Math.abs(o[1] - x.p[1]) < vb[3] * .08; })) return;
          seen[x.c.city] = 1; picked.push(x.p);
          rmap.mark(x.p, esc(x.c.city), 'cqhm-place-label', (rmap.W / vb[2]) * .7);
        });
      rmap.draw();
    });
  }

  function renderResult(r) {
    current = r;
    show('result');
    if (r.kind === 'error') {
      view.innerHTML = '<div class="cqhm-wrap"><section class="cqhm-r-top"><div><p class="cqhm-r-where">ZIP ' + esc(r.zip) + '</p><h2 class="cqhm-r-h" data-cqhm-focus tabindex="-1">We could not load the hardness data just now.</h2>' +
        '<p class="cqhm-r-text">Please try again in a moment, or call us at <a href="tel:18009340051">1-800-934-0051</a> and we\'ll help.</p><p class="cqhm-rec-foot"><button type="button" class="cqhm-btn" data-cqhm-do="retry">Try again</button></p></div></section></div>';
      speak('The hardness data could not load. Try again.');
      focusView();
      return;
    }
    var hasFig = r.kind !== 'miss' && r.kind !== 'well-miss';
    var html = '<div class="cqhm-wrap"><section class="cqhm-r-top" aria-labelledby="cqhm-r-h">';
    if (hasFig) {
      var src = sourceHtml(r), caution = cautionHtml(r), cmp = compareHtml(r);
      html += '<div class="cqhm-r-fig-col" data-cqhm-figure><p class="cqhm-r-where">' + whereLine(r) + '</p><h2 class="cqhm-r-h" id="cqhm-r-h" data-cqhm-focus tabindex="-1">' + esc(headline(r)) + '</h2>' +
        '<div class="cqhm-r-fig"><p class="cqhm-r-num">' + (r.kind === 'near' || r.source === 'well' ? '<span class="cqhm-about">about</span>' : '') + '<span>' + gpgText(r.gpg) + '</span><small>gpg</small><span class="cqhm-r-mgl">' + num(r.ppm) + ' mg/L</span>' + bandTag(r) + '</p></div>' +
        scaleHtml({gpg: r.gpg, band: r.band, label: r.bandLabel, range: r.well && r.well.low != null ? [r.well.low / 17.1, r.well.high / 17.1] : null}) +
        (cmp ? '<p class="cqhm-r-compare">' + cmp + '</p>' : '') +
        '<details class="cqhm-r-details"><summary>Source details<span class="cqhm-caret" aria-hidden="true"></span></summary><div>' +
        (src ? '<p class="cqhm-r-source">' + src + '</p>' : '') +
        '<p class="cqhm-r-evidence">' + esc(evidenceSummary(r)) + '</p>' +
        (caution ? '<p class="cqhm-r-caution">' + caution + '</p>' : '') + '</div></details>' +
        '</div>' + resultMapHtml(r) + '</section>';
      var withImg = MEANS[r.band].every(function (x) { return x[2] != null && signImgs[x[2]]; });
      html += '<section class="cqhm-r-sec" aria-labelledby="cqhm-means-h"><h2 class="cqhm-r-h2" id="cqhm-means-h">What this means <em>for your home.</em></h2><ul class="cqhm-means' + (withImg ? ' cqhm-means--img' : '') + '">' + MEANS[r.band].map(function (x) {
        var im = withImg ? signImgs[x[2]] : null;
        return '<li>' + (im ? '<div class="cqhm-mean-photo"><img src="' + esc(im.src) + '" srcset="' + esc(im.srcset) + '" sizes="(min-width: 1024px) 380px, 100vw" width="760" height="570" alt="' + esc(im.alt) + '" loading="lazy" decoding="async"></div>' : '') + '<h3 class="cqhm-h3">' + x[0] + '</h3><p>' + x[1] + '</p></li>';
      }).join('') + '</ul></section></div>';
      html += '<section class="cqhm-rec cqhm-soft" data-cqhm-rec><div class="cqhm-wrap">' + recHtml(recommendation(r)) + '</div></section>';
    } else {
      html += '<div class="cqhm-r-fig-col" data-cqhm-figure><p class="cqhm-r-where">ZIP ' + esc(r.zip) + '</p><h2 class="cqhm-r-h" id="cqhm-r-h" data-cqhm-focus tabindex="-1">' +
        (r.kind === 'well-miss' ? 'We don\'t have recent well results near this ZIP yet.' : 'We don\'t have a figure for this ZIP yet.') + '</h2><p class="cqhm-r-text">' +
        (r.kind === 'well-miss' ? 'Recent well sampling is uneven, so many rural areas have no figure yet. A well test gives you your own number in days.' : 'No water utility report on our map is close enough to stand in for it. A water test gives you your own number in days.') +
        '</p></div>' + resultMapHtml(r) + '</section></div>';
      var tk = r.kind === 'well-miss' ? 'well_test' : 'city_test';
      html += '<section class="cqhm-rec cqhm-soft"><div class="cqhm-wrap"><div class="cqhm-rec-head"><div><p class="cqhm-eyebrow">Your next step</p><h2 class="cqhm-r-h2">Get your own <em>number.</em></h2></div></div>' +
        featured(tk, 'Your tap, tested', 'A lab test reads your hardness and the rest of your water, so the system fits the first time.', null) +
        '<p class="cqhm-rec-foot"><a class="cqhm-textlink" href="' + esc(ds.testsUrl) + '" data-cqhm-cta="tests">See all water tests</a></p></div></section>';
    }
    html += '<section class="cqhm-r-banner"><div class="cqhm-wrap"><div class="cqhm-banner"><div class="cqhm-banner-copy"><p class="cqhm-label">Free specialist help</p><h2 class="cqhm-banner-title">Rather have an expert <em>look at your water?</em></h2></div>' +
      '<p class="cqhm-banner-text">A Crystal Quest water specialist can choose and size the system with you, free.</p><div class="cqhm-banner-actions"><a class="cqhm-btn cqhm-btn--light" href="' + esc(ds.helpUrl) + '" data-cqhm-cta="specialist">Get a free recommendation</a><a class="cqhm-textlink cqhm-textlink--light" href="tel:18009340051" data-cqhm-cta="call">Call 1-800-934-0051</a></div></div></div></section>';
    view.innerHTML = html;
    watchChat($('[data-cqhm-figure]', view));
    requestAnimationFrame(function () { placeMarks(view); startResultMap(r); });
    speak(hasFig ? headline(r) + ' About ' + gpgText(r.gpg) + ' grains per gallon, ' + r.ppm + ' milligrams per liter.' : 'No figure for this ZIP code yet.');
    focusView();
    track('cq_quiz_result_view', {match: r.kind, source: r.source || 'city', band: r.bandKey || 'none'});
  }
  function rerenderRec() {
    var sec = $('[data-cqhm-rec] .cqhm-wrap', view);
    if (!sec || !current) return;
    sec.innerHTML = recHtml(recommendation(current));
    var feat = $('.cqhm-feat', sec); if (feat) feat.classList.add('is-swap');
    var input = $('input[name="cqhm-pref"]:checked', sec); if (input) input.focus({preventScroll: true});
  }
  function setPref(v) {
    if (!current || v === pref) return;
    pref = v;
    rerenderRec();
    track('cq_quiz_preference', {preference: pref, band: current.bandKey || 'none', match: current.kind, source: current.source || 'city'});
  }
  view.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'cqhm-pref') setPref(e.target.value);
  });

  /* ------------------------------------------------------------------ the page-owned buy block */
  root.addEventListener('click', function (e) {
    var ob = e.target.closest && e.target.closest('[data-cqhm-opt]');
    if (ob) {
      var key = ob.getAttribute('data-cqhm-opt'), i = Number(ob.getAttribute('data-i')), st = buyState[key], p = catalog[key];
      if (!st || !p) return;
      st.picks[i] = ob.getAttribute('data-v');
      if (!variantOf(p, st.picks)) { var alt = p.variants.filter(function (v) { return v.options[i] === st.picks[i]; })[0]; if (alt) st.picks = alt.options.slice(); }
      var feat = ob.closest('.cqhm-feat-copy');
      var wrap = feat && feat.querySelector('.cqhm-opts'), buy = feat && feat.querySelector('.cqhm-buy');
      if (feat && buy) {
        var tmp = document.createElement('div'); tmp.innerHTML = buyHtml(key);
        if (wrap) wrap.replaceWith(tmp.querySelector('.cqhm-opts')); buy.replaceWith(tmp.querySelector('.cqhm-buy'));
        var again = feat.querySelector('[data-cqhm-opt="' + key + '"][data-i="' + i + '"][data-v="' + CSS.escape(st.picks[i]) + '"]'); if (again) again.focus({preventScroll: true});
      }
      return;
    }
  });

  /* ------------------------------------------------------------------ the forms */
  function busy(on) { if (!go) return; go.setAttribute('aria-busy', on ? 'true' : 'false'); var s = go.querySelector('span'); if (s) s.textContent = on ? 'Checking...' : 'Check my water'; }
  function setError(msg) { if (errorEl) errorEl.textContent = msg || ''; if (field) field.classList.toggle('is-invalid', !!msg); if (zipInput) zipInput.setAttribute('aria-invalid', msg ? 'true' : 'false'); }

  function loadingView(z) {
    show('pending');
    view.innerHTML = '<div class="cqhm-wrap"><section class="cqhm-r-top cqhm-loading" role="status" aria-live="polite" aria-busy="true"><div><p class="cqhm-r-where">ZIP ' + esc(z) + '</p><h2 class="cqhm-r-h" data-cqhm-focus tabindex="-1">Checking your water...</h2>' +
      '<div class="cqhm-skel cqhm-skel--num"></div><div class="cqhm-skel"></div><div class="cqhm-skel cqhm-skel--short"></div></div><div class="cqhm-skel-map"></div></section></div>';
  }
  function runZip(zip, opts) {
    opts = opts || {};
    var z = String(zip || '').replace(/\D/g, '').slice(0, 5);
    if (!/^\d{5}$/.test(z)) { setError('Enter a five-digit ZIP code.'); if (zipInput && root.getAttribute('data-view') === 'landing') zipInput.focus({preventScroll: true}); return; }
    setError('');
    if (opts.source === 'well' && !wellsOn) { goHome(false); setError('Private-well estimates are unavailable. Test your own water to confirm its hardness.'); return; }
    /* Keep the keyboard open for corrections; dismiss it only for a valid lookup. */
    if (opts.via === 'form' && zipInput) zipInput.blur();
    var my = ++seq, src = opts.source === 'well' ? 'well' : 'city';
    if (!started) { started = true; track('cq_quiz_start', {screen: 'zip', via: opts.via || 'form'}); }
    if (current && current.zip !== z) pref = null;
    current = null;
    busy(true);
    var slow;
    if (opts.via === 'link') loadingView(z);
    else slow = setTimeout(function () { if (my === seq) loadingView(z); }, 260);
    if (opts.push !== false) setUrl({zip: z, source: src === 'well' ? 'well' : ''});
    if (zip2) zip2.value = '';
    L.lookup(z, {source: src}).then(function (r) {
      clearTimeout(slow);
      if (my !== seq) return;
      busy(false);
      track('cq_quiz_zip_lookup', {match: r.kind, source: src, band: r.bandKey || 'none'});
      if (r.kind === 'invalid') { goHome(false); setError('Enter a five-digit ZIP code.'); return; }
      renderResult(r);
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); runZip(zipInput && zipInput.value, {via: 'form'}); });
  }
  if (zipInput) zipInput.addEventListener('input', function () {
    var v = zipInput.value.replace(/\D/g, '').slice(0, 5);
    if (v !== zipInput.value) zipInput.value = v;
    if (errorEl && errorEl.textContent) setError('');
  });
  root.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.hasAttribute('data-cqhm-mini')) return;
    e.preventDefault();
    var inp = f.querySelector('input');
    var v = inp ? inp.value.replace(/\D/g, '').slice(0, 5) : '';
    if (!/^\d{5}$/.test(v)) { if (inp) { inp.setAttribute('aria-invalid', 'true'); inp.focus({preventScroll: true}); } return; }
    if (inp) inp.removeAttribute('aria-invalid');
    if (zipInput) zipInput.value = v;
    runZip(v, {via: 'again'});
  });

  function locate(btn) {
    if (!navigator.geolocation) { setError('Your browser cannot share a location. Enter your ZIP code instead.'); return; }
    var my = ++seq;
    if (btn) btn.setAttribute('aria-busy', 'true');
    navigator.geolocation.getCurrentPosition(function (pos) {
      if (my !== seq) { if (btn) btn.removeAttribute('aria-busy'); return; }
      L.coords().then(function (coords) {
        if (btn) btn.removeAttribute('aria-busy');
        if (my !== seq) return;
        coords.get('00000');
        var m = coords._map, best = null, bd = Infinity, la = pos.coords.latitude, lo = pos.coords.longitude, k = Math.cos(la * Math.PI / 180);
        if (m && m.forEach) m.forEach(function (p, z) { var dx = (p[1] - lo) * k, dy = p[0] - la, d = dx * dx + dy * dy; if (d < bd) { bd = d; best = z; } });
        if (!best) { setError('We could not match your location to a ZIP code. Enter your ZIP code instead.'); return; }
        if (zipInput) zipInput.value = best;
        runZip(best, {via: 'location'});
      }, function () { if (btn) btn.removeAttribute('aria-busy'); if (my !== seq) return; setError('We could not load the ZIP data just now. Enter your ZIP code and try again.'); });
    }, function () {
      if (btn) btn.removeAttribute('aria-busy');
      if (my !== seq) return;
      setError('We could not get your location. Enter your ZIP code instead.');
    }, {timeout: 10000, maximumAge: 600000});
  }

  root.addEventListener('click', function (e) {
    var stl = e.target.closest && e.target.closest('[data-cqhm-state-link]');
    if (stl) { e.preventDefault(); if (root.getAttribute('data-view') !== 'landing') show('landing'); openState(stl.getAttribute('data-cqhm-state-link'), {via: 'list'}); return; }
    var b = e.target.closest && e.target.closest('[data-cqhm-do]');
    if (b) {
      var d = b.getAttribute('data-cqhm-do');
      if (d === 'locate') locate(b);
      else if (d === 'home') { goHome(true); track('cq_quiz_back', {screen: root.getAttribute('data-view')}); }
      else if (d === 'us') { closeState(true); var sq = $('[data-cqhm-state-q]'); if (sq) sq.focus({preventScroll: true}); }
      else if (d === 'focus-zip') { if (zipInput) { zipInput.scrollIntoView({block: 'center', behavior: reduced ? 'auto' : 'smooth'}); zipInput.focus({preventScroll: true}); } }
      else if (d === 'pref') setPref(b.getAttribute('data-v'));
      else if (d === 'retry') { if (current && current.zip) runZip(current.zip, {source: current.source, push: false, via: 'retry'}); }
      return;
    }
    var c = e.target.closest && e.target.closest('[data-cqhm-cta]');
    if (c) track('cq_quiz_next_step', {target: c.getAttribute('data-cqhm-cta'), band: current && current.bandKey || 'none', match: current && current.kind || 'none', source: current && current.source || 'city', preference: pref || 'none'});
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lstate && root.getAttribute('data-view') === 'landing') closeState(true); });

  root.setAttribute('data-cqhm-runtime-ready', '');

  /* ------------------------------------------------------------------ a ZIP handed over by another page in sessionStorage
     (cq:hardness:zip, cq:hardness:source), or a ZIP or state in the address */
  (function () {
    var stored = '', storedSrc = '';
    try {
      stored = sessionStorage.getItem('cq:hardness:zip') || ''; storedSrc = sessionStorage.getItem('cq:hardness:source') || '';
      sessionStorage.removeItem('cq:hardness:zip'); sessionStorage.removeItem('cq:hardness:source');
    } catch (_) { /* storage blocked */ }
    if (/^\d{5}$/.test(stored) && !/[?&](zip|state)=/.test(location.search)) {
      if (zipInput) zipInput.value = stored;
      runZip(stored, {source: storedSrc, via: 'handoff', push: true});
      return;
    }
    var q0 = ''; try { q0 = (new URLSearchParams(location.search).get('state') || '').toUpperCase(); } catch (_) { /* old browsers */ }
    if (STATES[q0]) { openState(q0, {via: 'link', push: false, instant: true}); return; }
    route();
  })();

  /* ------------------------------------------------------------------ phones: hide the chat launcher while a ZIP form or a
     result figure is on screen (the 2026-10-18 review: it covered the ZIP field and the source line) */
  var chatSeen = [];
  var chatIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var i = chatSeen.indexOf(en.target);
      if (en.isIntersecting && i < 0) chatSeen.push(en.target);
      if (!en.isIntersecting && i >= 0) chatSeen.splice(i, 1);
    });
    chatSeen = chatSeen.filter(function (el) { return el.isConnected; });
    document.documentElement.classList.toggle('cqhm-chat-off', chatSeen.length > 0);
  }) : null;
  function watchChat(el) { if (chatIO && el) chatIO.observe(el); }
  watchChat(form);
  watchChat(mini);

  /* ------------------------------------------------------------------ scroll reveal */
  var reveal = $$('[data-cqhm-reveal], [data-cqhm-reveal-stagger]');
  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.hasAttribute('data-cqhm-reveal-stagger')) Array.prototype.forEach.call(el.children, function (ch, i) { ch.style.setProperty('--d', Math.min(i, 6) * 70 + 'ms'); });
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, {rootMargin: '0px 0px -8% 0px', threshold: 0.08});
    reveal.forEach(function (el) { io.observe(el); });
  } else reveal.forEach(function (el) { el.classList.add('is-in'); });
  placeMarks(root);

  /* FAQ: smooth open and close */
  $$('.cqhm-faq details').forEach(function (d) {
    var s = d.querySelector('summary'), body = d.querySelector('summary + div');
    if (!s || !body || reduced || !body.animate) return;
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.open) {
        var a = body.animate([{height: body.offsetHeight + 'px', opacity: 1}, {height: '0px', opacity: 0}], {duration: 280, easing: 'cubic-bezier(.65,0,.35,1)'});
        a.onfinish = function () { d.open = false; };
      } else {
        d.open = true;
        var h = body.offsetHeight;
        body.animate([{height: '0px', opacity: 0}, {height: h + 'px', opacity: 1}], {duration: 320, easing: 'cubic-bezier(.65,0,.35,1)'});
      }
    });
  });
})();
